module.exports = __webpack_public_path__ + "img/success-checkin.4f1dc85e.svg";